module.exports = __webpack_public_path__ + "img/top-logo-of-event.55376c79.png";